export const ImageBorderMode = {
  CLAMP: 0,
  REPEAT: 1,
  MIRROR: 2,
};

export const InterpolationMode = {
  NEAREST: 0,
  LINEAR: 1,
  CUBIC: 2,
};

export default {
  ImageBorderMode,
  InterpolationMode,
};
